import Icon from '../assets/raydium.webp';

export function RaydiumIcon({ className = '' }: { className?: string }) {
    return <img className={'size-[28px] ' + className} src={Icon} alt='Raydium Icon' />;
}
